import { encryptedLocalStorage, encryptedSessionStorage } from "./encrypt-storage";

const authHeader = () => {
  const token = encryptedLocalStorage.getItem("token") || encryptedSessionStorage.getItem("token");

  let header = {};
  if (token) {
    header = { Authorization: `Bearer ${token}` };
  }

  return header;
};

export default authHeader;
